import { tickerItems } from "@/mocks/evidence";

export default function Ticker() {
  const doubled = [...tickerItems, ...tickerItems];
  return (
    <div className="w-full overflow-hidden border-b border-background-200 bg-background-100">
      <div className="flex items-center">
        <div className="z-10 flex shrink-0 items-center gap-2 bg-primary-600 px-4 py-2.5 text-background-50 md:px-5">
          <i className="ri-flashlight-line text-sm" />
          <span className="text-xs font-semibold whitespace-nowrap">实时校对</span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="animate-marquee flex w-max items-center gap-10 px-6">
            {doubled.map((t, i) => (
              <span
                key={i}
                className="flex items-center gap-3 whitespace-nowrap text-xs text-foreground-600"
              >
                <span className="font-medium text-primary-700">{t.time}</span>
                <span>{t.text}</span>
                <i className="ri-arrow-right-s-line text-secondary-400" />
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}